export class ResultWithoutRecordsError extends Error {
  constructor () {
    super('Sem Registro, não há dados para exibir!')
    this.name = 'ResultWithoutRecordsError'
  }
}
